import { business, ReverseGeocoderServiceClient } from '@icabbi/api-gateway-client';
import apiInstance, { apiCall } from '@/helpers/apiInstance';

const defaultState = {
  suggestionServiceClient: null,
  reverseGeocoderClient: null,
};

const getters = {
  // eslint-disable-next-line no-shadow
  suggestionServiceClient: (state, getters, rootState, rootGetters) => ({ dispatch }) => {
    if (!state.suggestionServiceClient) {
      state.suggestionServiceClient = apiInstance({ dispatch, getters: rootGetters, Connector: business.SuggestionServiceConnector });
    }
    return state.suggestionServiceClient;
  },
  reverseGeocoderClient: (state, getters, rootState, rootGetters) => ({ dispatch }) => {
    if (!state.reverseGeocoderClient) {
      state.reverseGeocoderClient = apiInstance({ dispatch, getters: rootGetters, Connector: ReverseGeocoderServiceClient });
    }
    return state.reverseGeocoderClient;
  },
};

const actions = {
  getSuggestions: apiCall(async (context, { search, lang }) => {
    const suggestionServiceClient = context.getters.suggestionServiceClient(context);
    const { suggestions, source } = await suggestionServiceClient.getSuggestions({ params: { search, lang, limit: 5 } });
    const result = suggestions.length ? [...new Map(suggestions.map((item) => [item.description, item])).values()] : [];
    return result.map((suggestion) => ({ ...suggestion, source }));
  }),
  getSuggestionDetail: apiCall(async (context, { addressId, lang }) => {
    const suggestionServiceClient = context.getters.suggestionServiceClient(context);
    const result = await suggestionServiceClient.getSuggestionDetails(addressId, { params: { lang } });
    return result;
  }),
  geocode: apiCall(async (context, { location, lang }) => {
    const { lat, lng } = location;
    const options = {
      params: {
        lang,
        latitude: lat,
        longitude: lng,
      },
    };
    const response = await context.getters.reverseGeocoderClient(context).getReverseGeocode(options);

    if (!response.results.length) throw new Error('Please enable geolocation in your browser');

    const { description, locationTypes } = response.results[0];
    return { address: { description, locationTypes, coordinates: { latitude: lat, longitude: lng } } };
  }),
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
};
